<template>
  <div>
    <editor-menu-bubble :editor="editor" :keep-in-bounds="keepInBounds">
      <div
        slot-scope="{ commands, isActive, menu }"
        class="menububble"
        :class="{ 'is-active': menu.isActive }"
        :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
      >
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <strong>B</strong>
        </button>

        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <em>I</em>
        </button>
      </div>
    </editor-menu-bubble>
    <div class="editor">
      <editor class="editor__content h-100" :editor="editor" />
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBubble } from 'tiptap';
import { Bold, Italic, Placeholder } from 'tiptap-extensions';

export default {
  components: {
    editor: EditorContent,
    'editor-menu-bubble': EditorMenuBubble,
  },
  data() {
    return {
      debounceTimer: undefined,
      placeholder: 'Write a note about this customer...',
      keepInBounds: true,
      editor: this.createNewEditor(),
    };
  },
  watch: {
    '$route.params.customer_id': {
      handler: function (newCustomerParam, oldCustomerParam) {
        this.editor.destroy();
        this.$set(this, 'editor', this.createNewEditor());
      },
    },
    placeholder(newValue) {
      this.editor.extensions.options.placeholder.emptyNodeText = newValue;
    },
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    saveNote(event) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      const newTimer = setTimeout(
        (event) => {
          this.$store
            .dispatch('updateCustomer', {
              ...this.$store.state.customers.selectedCustomer,
              notes: event.getHTML(),
              addresses: undefined,
              phone_numbers: undefined,
              tins: undefined,
              emails: undefined,
            })
            .then(
              (response) => {},
              (errorResponse) => {
                if (
                  errorResponse.response !== undefined &&
                  errorResponse.response.status === 403
                ) {
                  this.$notify({
                    group: 'general',
                    type: 'error',
                    title: 'Permission denied',
                    duration: 5000,
                    text: 'You do not have permission to change this customers notes. Please contact your admin if you require this permission.',
                  });
                }
              },
            );
        },
        400,
        event,
      );
      this.$set(this, 'debounceTimer', newTimer);
    },
    createNewEditor() {
      return new Editor({
        content: this.$store.state.customers.selectedCustomer.notes,
        editable: true,
        extensions: [
          new Bold(),
          new Italic(),
          new Placeholder({
            emptyClass: 'is-empty',
            emptyNodeText: 'Write a note about this customer...',
            showOnlyWhenEditable: true,
          }),
        ],
        onUpdate: this.saveNote,
      });
    },
  },
};
</script>
<style lang="scss">
.editor {
  p {
    &.is-empty:first-child::before {
      content: attr(data-empty-text);
      float: left;
      color: $color-raven-40;
      pointer-events: none;
      height: 0;
      font-style: italic;
    }
  }

  &__content {
    .ProseMirror {
      height: 90px;
      overflow-y: scroll;
      overflow: -moz-scrollbars-none;
      -ms-overflow-style: none;
      padding-top: 5px;
      line-height: 20px;
      word-break: break-word;

      p {
        margin-bottom: 0px;
      }

      &::-webkit-scrollbar {
        width: 0 !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.menububble {
  position: absolute;
  display: flex;
  z-index: 20;
  background: $color-almost-black;
  border-radius: $border-radius-default;
  padding: 0.3rem;
  margin-bottom: 0.5rem;
  transform: translateX(-50%);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s, visibility 0.2s;

  &.is-active {
    opacity: 1;
    visibility: visible;
  }

  &__button {
    display: inline-flex;
    background: transparent;
    border: 0;
    color: $color-white;
    padding: 0.2rem 0.5rem;
    margin-right: 0.2rem;
    border-radius: 3px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    &.is-active {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
}
</style>
